import { Button, CircularProgress, Typography, useTheme } from "@mui/material";
import { useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import CustomTable from "../../../ui/CustomTable";
import TabsList from "../../../ui/TabsList";
import FilterForm from "./FilterForm";
import { useReports } from "../Provider";
import { useAuth } from "../../../services/auth";
import SitesCurrency from "../Render/SitesCurrency";
import Creator from "../Render/Creator";
import RatioRender from "../Render/Ratiorender";
import SubSalaryRender from "../Render/SubsalaryRender";
import SitesSales from "../Render/SitesSales";
import TotalAmount from "../Render/TotalAmount";
import TicketCount from "../Render/TicketCount";
import localDate from "../Render/localDate";
import localOutDate from "../Render/localOutDate";
import LocalDateEnd from "../Render/LocalDateEnd";
import LocalDateStart from "../Render/LocalDateStart";
import ShowServicesList from "../Render/ShowServicesList";
import CarCount from "../Render/CarCount";
import TrialSum from "../Render/TrialSum";
import CostOfficial from "../Render/CostOfficial";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useSite } from "../../Sites/Provider";
import localDateCell from "../Render/localDateCell";
import {
  safeLocalFormat,
  StyleDate,
  toLocal,
} from "../../../utilities/functions";
import DailySalesDate from "../Render/DailySalesDate";
import Services from "../Render/Services";
import SpotRender from "../Render/SpotRender";
import CarsAll from "../Render/CarsAll";
import PaidOption from "../Render/PaidOption";
import Official from "../Render/Official";
import CostTrial from "../Render/CostTrial";
import Tips from "../Render/Tips";
import TipsComma from "../Render/Normalization/Tips";
import TotalTips from "../Render/Normalization/TotalTips";
import TotalSales from "../Render/Normalization/TotalSales";
import AmountComma from "../Render/Normalization/Amount";
import PayrollRatio from "../Render/Normalization/PayrollRatio";
import AverageSalesNormalization from "../Render/Normalization/AverageSalesNormalization";
import TotalPayrollNormalization from "../Render/Normalization/TotalPayroll";
import ServicesStatus from "../Render/ServicesStatus";
import ZoneStatus from "../Render/ZoneStatus";
import SiteStatus from "../Render/SiteStatus";
import ServicesName from "../Render/ServicesName";
import TicketNormalization from "../Render/Normalization/TicketNormalization";
import SalesNormalization from "../Render/Normalization/SalesNormalization";
import TipsNormalization from "../Render/Normalization/TipsNormalization";
import TotalSalesNormalization from "../Render/Normalization/TotalSalesNormalization";
import PayrollNormalization from "../Render/Normalization/PayrollNormalization";
import PriceNormalization from "../Render/Normalization/PriceNormalization";
import TicketNumberNormalization from "../Render/Normalization/TicketNumberNormalization";
import ReservationCountNormalization from "../Render/Normalization/ReservationCountNormalization";
import NumberReservationsNormalization from "../Render/Normalization/NumberReservationsNormalization";
import AverageReservationsNormalization from "../Render/Normalization/AverageReservationsNormalization";
import StartShiftDate from "../Render/StartShiftDate";
import EndShiftDate from "../Render/EndShiftDate";
import CarsCheckOutNormalization from "../Render/Normalization/CarsCheckOutNormalization";
import USDAmount from "../Render/Normalization/USDAmount";
import NonUSDAmount from "../Render/Normalization/NonUSDAmount";
import ServiceCost from "../Render/Normalization/ServcieCost";
import SitesIdCurrency from "../Render/SitesIdCurrency";
import SitesIds from "../Render/SitesIds";
import SitesId from "../Render/SitesId";
import DateWithoutHours from "../Render/DateWithoutHours";
import GetPaidStatus, { getPaidStatusTitle } from "../Render/GetPaidStatus";
import EuroAmount from "../Render/Normalization/EuroAmount";
import TotalSalesEndShift from "../Render/Normalization/TotalSalesEndShift";
import ActualTips from "../Render/Normalization/ActualTips";
import ActualTipsNormalization from "../Render/Normalization/ActualTipsNormalization";
import ExpensesPayments from "../Render/ExpensesPayments";
import CheckInDate from "../Render/CheckInDate";
import RequestDate from "../Render/RequestDate";
import CheckoutDate from "../Render/CheckoutDate";
import TipsEndShift from "../Render/TipsEndShift";
import TotalSalesDailyShift from "../Render/TotalSalesEndShift";
import SalesTicketDailyShift from "../Render/SalesTicketDailyShift";

function ReportPage() {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  let params = useParams();
  let navigate = useNavigate();
  let { role } = useAuth();
  let theme = useTheme();
  const {
    state: { Names: sites },
  } = useSite();
  const {
    state: {
      listShift: SiteShiftList,
      listTransaction,
      PayServices,
      totalSize,
      ExportExcelList,
      FilterData,
      perPage,
      page,
      count,
      countShift,
      countExcel,
      countVoid,
      countSearchServices,
      //   countSearchServiceExcel,
      countVoidExcel,
      ExportVoidExcelList,
      listTransactionServices,
      listLessPayroll,
      listHighestPayroll,
      listSitesSales,
      listSitesTickets,
      listVoidTransactions,
      listPrevPayroll,
      EmployeesRoles,
      listTransactionPaySer,
      siteIdAtt,
      DailySales,
      ExportShiftExcelList,
      countShiftExcel,
      from,
      to,
      selectedSite,
      DailySalesByLocationList,
      MonthlySalesByLocationList,
      YearlySalesByLocationList,
      sitesZonesList,
      SearchByServicesList,
      //  ExportSearchServicesExcelList,
      SalesEndShiftList,
      ExportSalesEndShiftExcel,
      countEndShiftExcel,
      countSalesEndShift,
      listTransactionLive,
      countLive,
      countLiveExcel,
      ExportLiveTransactionExcel,
      DailySalesByShiftList,
      //    exportExcelSearchByService,
      listTransactionsCheckedOut,
      ExportTransactionsCheckedOutExcel,
      countCheckedOut,
    },
    fetchTransactionExcel,
    fetchVoidTransactionExcel,
    fetchShiftTransactionExcel,
    //fetchSearchByServicesExcel,
    fetchSalesEndShiftExcel,
    fetchLiveTransactionExcel,
    ExportExcelBackendSearchByService,
    fetchTransactionCheckedOutExcel,
    fetchTransactionBackendExcel,
    dispatch,
  } = useReports();

  const [selectedCols, setSelectedCols] = useState(params.name + " Reports");
  const [filterClick, setFilterClick] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  var DailySalesFilter = selectedSite
    ? DailySales?.filter((d) => d.siteId === selectedSite)
    : DailySales;

  const tabs = [{ title: params.name + " Reports", num: totalSize }];
  const getCols = (name) => {
    switch (name?.split(" ")[0]) {
      case "Transactions":
        return [
          {
            label: "Ticket Id",
            name: "id",
            showDashWhenEmpty: true,
          },
          {
            label: "Ticket Number",
            name: "number",
            showDashWhenEmpty: true,
          },
          {
            label: "Site ID",
            name: "siteId",
            showDashWhenEmpty: true,
          },
          {
            label: "Site Name",
            name: "siteName",
            showDashWhenEmpty: true,
          },
          {
            label: "Shift In",
            name: "shiftInId",
            showDashWhenEmpty: true,
          },
          {
            label: "Shift Out",
            name: "shiftOutId",
            showDashWhenEmpty: true,
          },
          {
            label: "In (Date & Time)",
            customRender: localDate,
          },
          {
            label: "Out (Date & Time)",
            customRender: localOutDate,
          },
          {
            label: "Driver In",
            name: "assignDriverIn",
            showDashWhenEmpty: true,
          },
          {
            label: "Driver Out",
            name: "assignDriverOut",
            showDashWhenEmpty: true,
          },
          {
            label: "Zone",
            name: "zoneTitle",
            showDashWhenEmpty: true,
          },
          {
            label: "service Names",
            customRender: Services,
          },
          {
            label: "Services Count",
            name: "serviceCount",
            showDashWhenEmpty: true,
          },
          {
            label: "Spot",
            name: "spot",
            customRender: SpotRender,
          },
          {
            label: "State",
            name: "status",
            showDashWhenEmpty: true,
          },
          {
            label: "Paid State",
            name: "paidStatus",
            showDashWhenEmpty: true,
          },
          {
            label: "Payment Type",
            name: "paymentType",
            showDashWhenEmpty: true,
          },
          {
            label: "Amount",
            name: "amount",
            customRender: AmountComma,
          },
          {
            label: "Tips",
            name: "tips",
            customRender: TipsComma,
          },
          {
            label: "Discount",
            name: "discount",
            showDashWhenEmpty: true,
          },
          {
            label: "Plan",
            name: "membershipPlan",
            customRender: ({ row }) => (
              <div>{row?.membershipPlan || "No Membership"}</div>
            ),
          },
          {
            label: "Name",
            name: "membershipName",
            showDashWhenEmpty: true,
          },
          {
            label: "Related Company",
            name: "relatedCompany",
            showDashWhenEmpty: true,
          },
          {
            label: "Car Model",
            name: "carMaker",
            showDashWhenEmpty: true,
          },

          {
            label: "Car Plate",
            name: "carPlate",
            showDashWhenEmpty: true,
          },
          {
            label: "Mobile",
            name: "mobile",
            showDashWhenEmpty: true,
          },
        ];

      case "Live":
        return [
          {
            label: "Number",
            name: "number",
            showDashWhenEmpty: true,
          },
          {
            label: "Code",
            name: "code",
            showDashWhenEmpty: true,
          },
          {
            label: "Transaction Time",
            name: "transactionTime",
            showDashWhenEmpty: true,
          },
          {
            label: "Paid Status",
            name: "paidStatusId",
            customRender: GetPaidStatus,
          },
          {
            label: "Zone",
            name: "zoneTitle",
            showDashWhenEmpty: true,
          },
          {
            label: "Requested Gate",
            name: "requestedGate",
            showDashWhenEmpty: true,
          },
        ];

      case "Voids":
        return [
          { label: "Ticket Id", name: "id" },
          {
            label: "Ticket Number",
            name: "number",
            showDashWhenEmpty: true,
          },
          {
            label: "In (Date & Time)",

            customRender: localDate,
          },
          {
            label: "Out (Date & Time)",

            customRender: localOutDate,
          },
          {
            label: "Zone",
            name: "zoneTitle",
            showDashWhenEmpty: true,
          },
          {
            label: "Void Reasons",
            name: "reason",
            showDashWhenEmpty: true,
          },
          { label: "Created By", name: "creator", customRender: Creator },
        ];
      case "TransactionsByService":
        return [
          {
            label: "Service Type",
            name: "serviceType",
            showDashWhenEmpty: true,
          },
          { label: "Service Title", customRender: ShowServicesList },
          { label: "Cars Count", customRender: CarCount },
          { label: "Cost Trial Sum", customRender: TrialSum },
          { label: "costOfficialSum", customRender: CostOfficial },
          { label: "Total Tips", name: "totalTips", customRender: TotalTips },
        ];
      case "TransactionsServicePayment":
        return [
          { label: "Service Type", name: "type" },
          {
            label: "Title",
            name: "title",
            showDashWhenEmpty: true,
          },
          {
            label: "Paid Option",
            customRender: PaidOption,
          },
          {
            label: "Cars",
            customRender: CarsAll,
          },
          {
            label: "Cost Trial",
            customRender: CostTrial,
          },
          {
            label: "Cost Official",
            customRender: Official,
          },
          {
            label: "Tips",
            customRender: Tips,
          },
        ];
      case "Shift":
        return [
          {
            label: "Shift Id",
            name: "id",
            showDashWhenEmpty: true,
          },
          {
            label: "In (Date & Time)",
            name: "startDate",
            customRender: LocalDateStart,
          },
          {
            label: "Out (Date & Time)",
            name: "endDate",
            customRender: LocalDateEnd,
          },
        ];
      case "TransactionsCheckedOut":
        return [
          {
            label: "Number",
            name: "number",
            showDashWhenEmpty: true,
          },
          {
            label: "Mobile",
            name: "mobile",
            showDashWhenEmpty: true,
          },
          {
            label: "Plate",
            name: "plate",
            showDashWhenEmpty: true,
          },
          {
            label: "Check In",
            name: "checkInDate",
            customRender: CheckInDate,
          },
          {
            label: "Request Date",
            name: "requestDate",
            customRender: RequestDate,
          },
          {
            label: "Check Out",
            name: "checkOutDate",
            customRender: CheckoutDate,
          },
          {
            label: "Duration",
            name: "duration",
            showDashWhenEmpty: true,
          },
        ];

      case "EmployeesRoles":
        return [
          { label: "Date", name: "date", customRender: localDateCell },
          { label: "Role", name: "role", showDashWhenEmpty: true },
          {
            label: "Employee Count",
            name: "employeesCount",
            showDashWhenEmpty: true,
          },
        ];
      case "DailySales":
        return [
          { label: "Date", customRender: DailySalesDate },
          {
            label: "Site Id",
            name: "siteId",
            showDashWhenEmpty: true,
          },
          {
            label: "Site Name",
            name: "siteName",
            searchDropdown: true,
            showDashWhenEmpty: true,
          },
          {
            label: "Total Sales",
            name: "totalSales",
            customRender: TotalSales,
          },
          {
            label: "Total Payroll",
            name: "totalPayrolls",
            customRender: TotalPayrollNormalization,
          },
          {
            label: "Payroll Ratio",
            name: "payrollRatio",
            customRender: PayrollRatio,
          },
          {
            label: "Average Sales",
            name: "averageSales",
            customRender: AverageSalesNormalization,
          },
        ];
      case "LessPayroll":
        return [
          {
            label: "Currency",
            name: "currency",
            showDashWhenEmpty: true,
          },
          {
            label: "Sites",
            customRender: SitesCurrency,
          },
          {
            label: "Sub Salary",
            customRender: SubSalaryRender,
          },
          {
            label: "Ratio",
            customRender: RatioRender,
          },
        ];
      case "HighestPayroll":
        return [
          {
            label: "Currency",
            name: "currency",
            showDashWhenEmpty: true,
          },
          {
            label: "Sites Id",
            customRender: SitesIdCurrency,
          },
          {
            label: "Sites",
            customRender: SitesCurrency,
          },
          {
            label: "Sub Salary",
            customRender: SubSalaryRender,
          },
          {
            label: "Ratio",
            customRender: RatioRender,
          },
        ];
      case "SiteBySales":
        return [
          {
            label: "Site Id",
            customRender: SitesIds,
          },
          {
            label: "Site Name",
            customRender: SitesSales,
          },
          {
            label: "Total Amount",
            customRender: TotalAmount,
            name: "totalAmount",
            sortable: true,
          },
        ];
      case "SitesByTickets":
        return [
          { label: "Site Id", customRender: SitesId },
          {
            label: "Site Name",
            customRender: SitesSales,
          },
          {
            label: "Ticket Count",
            customRender: TicketCount,
            name: "ticketCount",
            sortable: true,
          },
        ];
      case "PreviewPayroll":
        return [
          { label: "col1" },
          {
            label: "col2",
          },
        ];
      case "DailySalesByShift":
        return [
          { label: "Day Date", name: "dayDate", showDashWhenEmpty: true },
          {
            label: "Shift Id",
            name: "shiftId",
            showDashWhenEmpty: true,
          },
          { label: "Start Shift", name: "startShift", showDashWhenEmpty: true },
          { label: "End Shift", name: "endShift", showDashWhenEmpty: true },
          { label: "Site Id", name: "siteId", showDashWhenEmpty: true },
          {
            label: "Site Name",
            name: "siteName",
            showDashWhenEmpty: true,
          },
          {
            label: "Tickets Count",
            name: "ticketsCount",
            showDashWhenEmpty: true,
          },
          {
            label: "Sales Tickets",
            name: "salesTickets",
            customRender: SalesTicketDailyShift,
          },
          {
            label: "Actual Tips",
            name: "actualTips",
            customRender: TipsEndShift,
          },
          {
            label: "Total Sales",
            name: "totalSales",
            customRender: TotalSalesDailyShift,
          },
        ];
      case "DailySalesLocation":
        return [
          { label: "Site Id", name: "siteId", showDashWhenEmpty: true },
          { label: "Site Name", name: "siteName", showDashWhenEmpty: true },
          {
            label: "Date",
            name: "dayDate",
            customRender: DateWithoutHours,
          },
          {
            label: "Tickets Count",
            name: "ticketsCount",
            customRender: TicketNormalization,
          },
          {
            label: "Sales Tickets",
            name: "salesTickets",
            customRender: SalesNormalization,
          },
          {
            label: "Tips",
            name: "tips",
            customRender: TipsNormalization,
          },
          {
            label: "Actual Tips",
            name: "actualTips",
            customRender: ActualTipsNormalization,
          },
          {
            label: "Total Sales",
            name: "totalSales",
            customRender: TotalSalesNormalization,
          },
          {
            label: "Total Payrolls",
            name: "totalPayrolls",
            customRender: PayrollNormalization,
          },
          {
            label: "Hours Count",
            name: "hoursCount",
            showDashWhenEmpty: true,
          },
          {
            label: "Total Reservations",
            name: "reservationsCount",
            customRender: ReservationCountNormalization,
          },
          {
            label: "Number of Reservations",
            name: "reservationsNumber",
            customRender: NumberReservationsNormalization,
          },
          {
            label: "Reservations Average",
            name: "reservationsAverage",
            customRender: AverageReservationsNormalization,
          },
        ];

      case "MonthlySalesLocation":
        return [
          { label: "Site Id", name: "siteId", showDashWhenEmpty: true },
          { label: "Site Name", name: "siteName", showDashWhenEmpty: true },
          {
            label: "Date",
            name: "date",
            showDashWhenEmpty: true,
          },
          {
            label: "Tickets Count",
            name: "ticketsCount",
            customRender: TicketNormalization,
          },
          {
            label: "Sales Tickets",
            name: "salesTickets",
            customRender: SalesNormalization,
          },
          {
            label: "Tips",
            name: "tips",
            customRender: TipsNormalization,
          },
          {
            label: "Total Sales",
            name: "totalSales",
            customRender: TotalSalesNormalization,
          },
          {
            label: "Total Payrolls",
            name: "totalPayrolls",
            customRender: PayrollNormalization,
          },
          {
            label: "Hours Count",
            name: "hoursCount",
            showDashWhenEmpty: true,
          },
        ];

      case "YearlySalesLocation":
        return [
          { label: "Year", name: "year", showDashWhenEmpty: true },
          {
            label: "Tickets Count",
            name: "ticketsCount",
            customRender: TicketNormalization,
          },
          {
            label: "Sales Tickets",
            name: "salesTickets",
            customRender: SalesNormalization,
          },
          {
            label: "Tips",
            name: "tips",
            customRender: TipsNormalization,
          },

          {
            label: "Total Sales",
            name: "totalSales",
            customRender: TotalSalesNormalization,
          },
        ];

      case "SitesZonesServices":
        return [
          { label: "Site Id", name: "siteId", showDashWhenEmpty: true },
          { label: "Site Name", name: "siteName", showDashWhenEmpty: true },
          {
            label: "Site Status",
            name: "siteStatus",
            customRender: SiteStatus,
          },
          {
            label: "Zone Name",
            name: "zoneName",
            showDashWhenEmpty: true,
          },
          {
            label: "Zone Status",
            name: "zoneStatus",
            customRender: ZoneStatus,
          },

          {
            label: "Service Name",
            name: "serviceName",
            showDashWhenEmpty: true,
          },
          {
            label: "Service Status",
            name: "serviceStatus",
            customRender: ServicesStatus,
          },
          { label: "Service Type Name", name: "serviceTypeName" },
          {
            label: "Service Price",
            name: "servicePrice",
            customRender: PriceNormalization,
          },
        ];

      case "SearchByServices":
        return [
          { label: "Site Id", name: "siteId", showDashWhenEmpty: true },
          { label: "Site Name", name: "siteName", showDashWhenEmpty: true },
          {
            label: "Services Name",
            name: "servicesName",
            customRender: ServicesName,
          },
          {
            label: "Cost",
            name: "cost",
            customRender: ServiceCost,
          },
          {
            label: "Tips",
            name: "tips",
            showDashWhenEmpty: true,
          },
          {
            label: "Ticket Number",
            name: "ticketNumber",
            customRender: TicketNumberNormalization,
          },
          {
            label: "check In Date",
            customRender: localDate,
          },
          {
            label: "check Out Date",
            customRender: localOutDate,
          },

          { label: "Zone Title", name: "zoneTitle", showDashWhenEmpty: true },
          { label: "Status", name: "status", showDashWhenEmpty: true },
          { label: "Paid Status", name: "paidStatus", showDashWhenEmpty: true },
        ];
      case "SalesEndShift":
        return [
          { label: "Site Id", name: "siteId", showDashWhenEmpty: true },
          { label: "Site Name", name: "siteName", showDashWhenEmpty: true },
          {
            label: "Start Shift",
            name: "startShift",
            customRender: StartShiftDate,
          },
          {
            label: "End Shift",
            name: "endShift",
            customRender: EndShiftDate,
          },
          {
            label: "Cars CheckOut",
            name: "carsCheckedOut",
            customRender: CarsCheckOutNormalization,
          },
          {
            label: "First CheckIn",
            name: "firstCheckIn",
            showDashWhenEmpty: true,
          },
          {
            label: "Last CheckIn",
            name: "lastCheckIn",
            showDashWhenEmpty: true,
          },
          {
            label: "USD Amount",
            name: "usdAmount",
            customRender: USDAmount,
          },
          {
            label: "Non USD Amount",
            name: "nonUSDAmount",
            customRender: NonUSDAmount,
          },
          {
            label: "Euro Amount",
            name: "euroAmount",
            customRender: EuroAmount,
          },
          {
            label: "Total Sales",
            name: "totalSales",
            customRender: TotalSalesEndShift,
          },
          {
            label: "Actual Tips",
            name: "actualTips",
            customRender: ActualTips,
          },
          {
            label: "Expense Payments",
            name: "expensePaymentsList",
            customRender: ExpensesPayments,
          },
        ];
      default:
    }
  };

  const getData = (name) => {
    switch (name?.split(" ")[0]) {
      case "Transactions":
        return listTransaction;

      case "Voids":
        return listVoidTransactions;

      case "TransactionsByService":
        return listTransactionServices;

      case "Live":
        return listTransactionLive;

      case "TransactionsServicePayment":
        return PayServices;

      case "Shift":
        return SiteShiftList;

      case "EmployeesRoles":
        return EmployeesRoles;

      case "DailySales":
        const sumTotalSales = DailySalesFilter.reduce(
          (sum, item) => sum + (item?.totalSales || 0),
          0,
        );
        const sumTotalPayroll = DailySalesFilter.reduce(
          (sum, item) => sum + (item?.totalPayrolls || 0),
          0,
        );
        const payrollRatio =
          sumTotalSales !== 0
            ? Number(sumTotalPayroll / sumTotalSales) * 100
            : 0;
        return [
          ...DailySalesFilter,
          {
            totalSales: sumTotalSales,
            totalPayrolls: sumTotalPayroll,
            payrollRatio: payrollRatio,
          },
        ];
      case "DailySalesByShift":
        return DailySalesByShiftList;
      case "DailySalesLocation":
        return DailySalesByLocationList;

      case "MonthlySalesLocation":
        return MonthlySalesByLocationList;

      case "YearlySalesLocation":
        return YearlySalesByLocationList;

      case "SitesZonesServices":
        return sitesZonesList;

      case "LessPayroll":
        return listLessPayroll;

      case "HighestPayroll":
        return listHighestPayroll;

      case "SiteBySales":
        return listSitesSales;

      case "SitesByTickets":
        return listSitesTickets;

      case "PreviewPayroll":
        return listPrevPayroll;

      case "SearchByServices":
        return SearchByServicesList;

      case "SalesEndShift":
        return SalesEndShiftList;
      case "TransactionsCheckedOut":
        return listTransactionsCheckedOut;

      default:
    }
  };

  const getObj = (name) => {
    switch (name) {
      case "Transactions":
        return {
          company: true,
          site: 0,
          fromTime: true,
          toTime: true,
          fromDate: true,
          toDate: true,
          isAllSites: false,
        };
      case "Shift":
        return {
          company: true,
          site: true,
          fromTime: true,
          toTime: true,
          fromDate: true,
          toDate: true,
        };
      default:
        return {};
    }
  };

  const handleDetail = (id) => {
    navigate(`detail/${id}`);
  };

  // handle change page size
  const changePageSize = (size) => {
    dispatch({ type: "set_per_page", payload: size });
  };
  // Export Transaction excel function
  const handleExportExcel = async () => {
    // for (var i = 2; i <= countExcel; i++) {
    //   await fetchTransactionExcel(FilterData, i, 100);
    // }
    // var newArr = new Array([]);
    // var site = sites.filter((s) => s.id === siteIdAtt).map((ss) => ss.name);
    // newArr.push({
    //   Filter: `Site Name:   ${site[0]}, From:  ${
    //     from ? toLocal(from) : ""
    //   }, To:  ${to ? toLocal(to) : ""}`,
    // });
    // for (let i = 0; i < ExportExcelList?.length; i++) {
    //   newArr = newArr.concat(ExportExcelList[i]);
    // }
    // newArr.forEach((a) => {
    //   a["checkInDate"] = a["checkInDate"]
    //     ? tolocalDate(a?.["checkInDate"])
    //     : "";
    //   a["checkOutDate"] = a["checkOutDate"]
    //     ? tolocalDate(a?.["checkOutDate"])
    //     : "";
    //   if (a) {
    //     a["serviceNames"] = a?.["serviceNames"]?.toString();
    //   } else {
    //   }
    // });
    // var fileName = "Transactions Report File";
    // const ws = XLSX.utils.json_to_sheet(newArr, {
    //   origin: -1,
    // });
    // ws["!cols"] = [
    //   { width: 50 },
    //   { width: 50 },
    //   { width: 50 },
    //   { width: 50 },
    //   { width: 15 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 15 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 15 },
    //   { width: 15 },
    //   { width: 15 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 25 },
    // ];
    // const wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, "Info");
    // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    // const data = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(data, fileName + fileExtension);
    try {
      await fetchTransactionBackendExcel(
        FilterData?.cid,
        FilterData?.sid,
        FilterData,
      );
    } catch (error) {
      console.log(error, "error");
    }
  };
  // Export Void Transaction list To Excel File
  const handleVoidExportExcel = async () => {
    for (var i = 2; i <= countVoidExcel; i++) {
      await fetchVoidTransactionExcel({ sid: siteIdAtt }, i, 100);
    }
    var newArr = new Array([]);
    var site = sites.filter((s) => s.id === siteIdAtt).map((ss) => ss.name);

    newArr.push({
      Filter: `Site Name:   ${site[0]}, From:  ${
        from ? toLocal(from) : ""
      }, To:  ${to ? toLocal(to) : ""}`,
    });

    for (let i = 0; i < ExportVoidExcelList.length; i++) {
      newArr = newArr.concat(ExportVoidExcelList[i]);
    }
    newArr.forEach((a) => {
      a["checkInDate"] = a["checkInDate"]
        ? safeLocalFormat(a["checkInDate"])
        : "";
      a["checkOutDate"] = a["checkOutDate"]
        ? safeLocalFormat(a["checkOutDate"])
        : "";
    });

    var fileName = "Void Transactions Report";
    const ws = XLSX.utils.json_to_sheet(newArr, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 15 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  // Export Shift list To Excel File
  const handleShiftExportExcel = async () => {
    for (var i = 2; i <= countShiftExcel; i++) {
      await fetchShiftTransactionExcel({ sid: siteIdAtt }, i, 100);
    }
    var newArr = new Array([]);
    var site = sites.filter((s) => s.id === siteIdAtt).map((ss) => ss.name);
    newArr.push({
      Filter: `Site Name:   ${site[0]}, From:  ${
        from ? toLocal(from) : ""
      }, To:  ${to ? toLocal(to) : ""}`,
    });
    for (let i = 0; i < ExportShiftExcelList.length; i++) {
      newArr = newArr.concat(ExportShiftExcelList[i]);
    }
    newArr.forEach((a) => {
      a["startDate"] = a["startDate"] ? safeLocalFormat(a["startDate"]) : "";
      a["endDate"] = a["endDate"] ? safeLocalFormat(a["endDate"]) : "";
    });
    var fileName = "Shifts Report";
    const ws = XLSX.utils.json_to_sheet(newArr, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 50 }, { width: 50 }, { width: 40 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const EmployeeRoleExcel = () => {
    var fileName = "Employee Roles Report";
    var site = sites.filter((s) => s.id === siteIdAtt).map((ss) => ss.name);
    var array = new Array([]);
    array.push({ Filter: "" });
    array.push({
      Filter: `Site Name: ${site[0]}|From: ${from ? toLocal(from) : ""}|To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i <= EmployeesRoles.length; i++) {
      array.push({
        Role: EmployeesRoles[i]?.role,
        Date: EmployeesRoles[i]?.date,
        EmployeeCount: EmployeesRoles[i]?.employeesCount,
      });
    }

    const ws = XLSX.utils.json_to_sheet(array, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 70 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const DailySalesExcel = () => {
    var fileName = "Daily Sales Report";
    var DailyExcelArray = new Array([]);
    DailyExcelArray.push({
      Filter: `From: ${from ? toLocal(from) : ""}|To:${to ? toLocal(to) : ""}`,
    });
    let SumTotalSales = 0;
    let SumTotalPayrolls = 0;

    for (var i = 0; i < DailySalesFilter.length; i++) {
      SumTotalSales += DailySalesFilter[i]?.totalSales || 0;
      SumTotalPayrolls += DailySalesFilter[i]?.totalPayrolls || 0;
      DailyExcelArray.push({
        Date: DailySalesFilter[i]?.date
          ? StyleDate(DailySalesFilter[i]?.date)
          : "",
        SiteId: DailySalesFilter[i]?.siteId,
        SiteName: DailySalesFilter[i]?.siteName,
        TotalSales: DailySalesFilter[i]?.totalSales,
        TotalPayrolls: DailySalesFilter[i]?.totalPayrolls,
        PayrollRatio: DailySalesFilter[i]?.payrollRatio,
        AverageSales: DailySalesFilter[i]?.averageSales,
      });
    }

    const SumPayrollRatio =
      SumTotalSales > 0 ? Number(SumTotalPayrolls / SumTotalSales) * 100 : 0;

    DailyExcelArray.push({
      TotalSales: `Total Sales Sum: ${SumTotalSales}`,
      TotalPayrolls: `Total Payrolls Sum: ${SumTotalPayrolls}`,
      PayrollRatio: `Ratio: ${SumPayrollRatio}`,
    });
    const ws = XLSX.utils.json_to_sheet(DailyExcelArray, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 70 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const TicketExcel = () => {
    var fileName = "Sites By Ticket Report";
    var SitesTicketExcelArray = new Array([]);
    SitesTicketExcelArray.push({
      Filter: `From:  ${from ? toLocal(from) : ""}, To:  ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i < listSitesTickets.length; i++) {
      SitesTicketExcelArray.push({
        siteId: listSitesTickets[i].site.id,
        siteName: listSitesTickets[i].site.siteName,
        TicketCount: listSitesTickets[i].ticketCount,
      });
    }
    const ws = XLSX.utils.json_to_sheet(SitesTicketExcelArray, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 50 }, { width: 20 }, { width: 20 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const SalesExcel = () => {
    var fileName = "Sites By Sales Report";
    var SitesSalesExcelArray = new Array([]);
    SitesSalesExcelArray.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i < listSitesSales.length; i++) {
      SitesSalesExcelArray.push({
        SiteId: listSitesSales[i].site.id,
        SiteName: listSitesSales[i].site.siteName,
        TotalAmount: listSitesSales[i].totalAmount,
      });
    }

    const ws = XLSX.utils.json_to_sheet(SitesSalesExcelArray, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 20 }, { width: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const TransactionServicesExcel = () => {
    var fileName = "Transaction By Service Report";
    var site = sites.filter((s) => s.id === siteIdAtt).map((ss) => ss.name);
    var arr1 = new Array([]);
    var arr0 = new Array([]);
    arr0.push({
      Filter: `Site Name:${site[0]}|From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    arr1.push({
      Filter: `Site Name:${site[0]}|From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i < listTransactionServices[0].details.length; i++) {
      arr0.push({
        ServiceTitle: listTransactionServices[0].details[i].serviceTitle,
        CostOfficialSum: listTransactionServices[0].details[i].costOfficialSum,
        CostTrialSum: listTransactionServices[0].details[i].costTrialSum,
        CarCount: listTransactionServices[0].details[i].carsCount,
      });
    }
    for (let i = 0; i < listTransactionServices[1].details.length; i++) {
      arr1.push({
        ServiceTitle: listTransactionServices[1].details[i].serviceTitle,
        CostOfficialSum: listTransactionServices[1].details[i].costOfficialSum,
        CostTrialSum: listTransactionServices[1].details[i].costTrialSum,
        CarCount: listTransactionServices[1].details[i].carsCount,
      });
    }
    arr0.push({
      CostOfficialSum: listTransactionServices[0].costOfficialSum,
      CostTrialSum: listTransactionServices[0].costTrialSum,
      CarCount: listTransactionServices[0].carsCount,
      TotalTips: listTransactionServices[0].totalTips,
    });
    arr1.push({
      CostOfficialSum: listTransactionServices[1].costOfficialSum,
      CostTrialSum: listTransactionServices[1].costTrialSum,
      CarCount: listTransactionServices[1].carsCount,
      TotalTips: listTransactionServices[1].totalTips,
    });
    listTransactionServices.shift();

    const wsFixed = XLSX.utils.json_to_sheet(arr1, {
      origin: -1,
    });
    wsFixed["!cols"] = [
      { width: 70 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    const wsHourly = XLSX.utils.json_to_sheet(arr0, {
      origin: -1,
    });
    wsHourly["!cols"] = [
      { width: 70 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsFixed, "Fixed Service");
    XLSX.utils.book_append_sheet(wb, wsHourly, "Hourly Service");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const LessPayrollExcel = () => {
    var fileName = "Less Payroll Report";
    const wb = XLSX.utils.book_new();
    var LessNewArray = new Array([]);
    LessNewArray.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To:${to ? toLocal(to) : ""}`,
    });

    for (var i = 0; i <= listLessPayroll.length - 1; i++) {
      listLessPayroll[i].sites.map((dailyItem) =>
        LessNewArray.push({
          SiteName: dailyItem.site.siteName,
          SubSalary: dailyItem.subSalary,
          Ratio: dailyItem.ratio,
          Currency: dailyItem.currency,
        }),
      );
    }
    const ws = XLSX.utils.json_to_sheet(LessNewArray, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 70 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, "Less Payroll Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const HighPayrollExcel = () => {
    var fileName = "High Payroll Report";
    const wb = XLSX.utils.book_new();
    var HighNewArray = new Array([]);
    HighNewArray.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i <= listHighestPayroll.length - 1; i++) {
      listHighestPayroll[i].sites.map((dailyItem) =>
        HighNewArray.push({
          SiteId: dailyItem.site.id,
          SiteName: dailyItem.site.siteName,
          SubSalary: dailyItem.subSalary,
          Ratio: dailyItem.ratio,
          Currency: dailyItem.currency,
        }),
      );
    }
    const ws = XLSX.utils.json_to_sheet(HighNewArray, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 70 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, "Highest Payroll Data");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const handlePaySerExportExcel = () => {
    var fileName = "Transaction By Service and Payment Report";
    var site = sites.filter((s) => s.id === siteIdAtt).map((ss) => ss.name);
    var arr = new Array([]);

    for (
      let index = 0;
      index < listTransactionPaySer[0].details.length;
      index++
    ) {
      arr.push({
        ServiceType: listTransactionPaySer[0].serviceType,
        ServiceTitle: listTransactionPaySer[0].details[index].serviceTitle,
        PaidOption: ["Cash", "C.C", "E.C.C", "Void", "Company", "Elite"],
        cars: [
          listTransactionPaySer[0]?.details[index]?.carsCashCount,
          listTransactionPaySer[0]?.details[index]?.carsCCCount,
          listTransactionPaySer[0]?.details[index]?.carsEccCount,
          listTransactionPaySer[0]?.details[index]?.carsVoidCount,
          listTransactionPaySer[0]?.details[index]?.carsCompCount,
          listTransactionPaySer[0]?.details[index]?.carsEliteCount,
        ],
        costTrial: [
          listTransactionPaySer[0]?.details[
            index
          ]?.cashCostTrial?.toLocaleString(),
          listTransactionPaySer[0]?.details[
            index
          ]?.ccCostTrial?.toLocaleString(),
          listTransactionPaySer[0]?.details[
            index
          ]?.eccCostTrial?.toLocaleString(),
          0,
          listTransactionPaySer[0]?.details[
            index
          ]?.compCostTrial?.toLocaleString(),
          listTransactionPaySer[0]?.details[
            index
          ]?.eliteCostTrial?.toLocaleString(),
        ],
        costOfficial: [
          listTransactionPaySer[0]?.details[
            index
          ]?.cashCostOfficial?.toLocaleString(),
          listTransactionPaySer[0]?.details[
            index
          ]?.ccCostOfficial?.toLocaleString(),
          listTransactionPaySer[0]?.details[
            index
          ]?.eccCostOfficial?.toLocaleString(),
          0,
          listTransactionPaySer[0]?.details[
            index
          ]?.compCostOfficial?.toLocaleString(),
          listTransactionPaySer[0]?.details[
            index
          ]?.eliteCostOfficial?.toLocaleString(),
        ],
        costTips: [
          listTransactionPaySer[0]?.details[index]?.cashTips,
          listTransactionPaySer[0]?.details[index]?.ccTips,
          listTransactionPaySer[0]?.details[index]?.eccTips,
          0,
          listTransactionPaySer[0]?.details[index]?.compTips,
          listTransactionPaySer[0]?.details[index]?.eliteTips,
        ],
      });
      arr.push({
        ServiceType: "",
        ServiceTitle: "",
        PaidOption: ["Total"],
        cars: [listTransactionPaySer[0]?.details[index]?.serviceCarsCount],
        costTrial: [
          listTransactionPaySer[0]?.details[index]?.serviceCostTrialSum,
        ],
        costOfficial: [
          listTransactionPaySer[0]?.details[index]?.serviceCostOfficialSum,
        ],
        costTips: [listTransactionPaySer[0]?.details[index]?.serviceTipsSum],
      });
      arr.push({
        ServiceType: "",
        ServiceTitle: "",
        PaidOption: [""],
        cars: [],
        costTrial: [],
        costOfficial: [],
        costTips: [],
      });
    }
    var arr2 = new Array([]);
    arr2.push({
      Filter: `Site Name:${site[0]}|From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (let index = 0; index < arr.length; index++) {
      for (let j = 0; j < arr[index]?.PaidOption?.length; j++) {
        arr2.push({
          serviceType: arr[index].ServiceType,
          serviceTitle: arr[index].ServiceTitle,
          PaidOption: arr[index].PaidOption[j],
          Cars: arr[index]?.cars[j],
          CostTrial: arr[index]?.costTrial[j],
          CostOfficial: arr[index]?.costOfficial[j],
          CostTips: arr[index]?.costTips[j],
        });
      }
    }

    /** for fixed */
    var arrFixed = new Array([]);
    for (
      let index = 0;
      index < listTransactionPaySer[1].details.length;
      index++
    ) {
      arrFixed.push({
        ServiceType: listTransactionPaySer[1].serviceType,
        ServiceTitle: listTransactionPaySer[1].details[index].serviceTitle,
        PaidOption: ["Cash", "C.C", "E.C.C", "Void", "Company"],
        cars: [
          listTransactionPaySer[1]?.details[index]?.carsCashCount,
          listTransactionPaySer[1]?.details[index]?.carsCCCount,
          listTransactionPaySer[1]?.details[index]?.carsEccCount,
          listTransactionPaySer[1]?.details[index]?.carsVoidCount,
          listTransactionPaySer[1]?.details[index]?.carsCompCount,
        ],
        costTrial: [
          listTransactionPaySer[1]?.details[index]?.cashCostTrial,
          listTransactionPaySer[1]?.details[index]?.ccCostTrial,
          listTransactionPaySer[1]?.details[index]?.eccCostTrial,
          0,
          listTransactionPaySer[1]?.details[index]?.compCostTrial,
        ],
        costOfficial: [
          listTransactionPaySer[1]?.details[index]?.cashCostOfficial,
          listTransactionPaySer[1]?.details[index]?.ccCostOfficial,
          listTransactionPaySer[1]?.details[index]?.eccCostOfficial,
          0,
          listTransactionPaySer[1]?.details[index]?.compCostOfficial,
        ],
        costTips: [
          listTransactionPaySer[1]?.details[index]?.cashTips,
          listTransactionPaySer[1]?.details[index]?.ccTips,
          listTransactionPaySer[1]?.details[index]?.eccTips,
          0,
          listTransactionPaySer[1]?.details[index]?.compTips,
        ],
      });
      arrFixed.push({
        ServiceType: "",
        ServiceTitle: "",
        PaidOption: ["Total"],
        cars: [listTransactionPaySer[1]?.details[index]?.serviceCarsCount],
        costTrial: [
          listTransactionPaySer[1]?.details[index]?.serviceCostTrialSum,
        ],
        costOfficial: [
          listTransactionPaySer[1]?.details[index]?.serviceCostOfficialSum,
        ],
        costTips: [listTransactionPaySer[1]?.details[index]?.serviceTipsSum],
      });
      arrFixed.push({
        ServiceType: "",
        ServiceTitle: "",
        PaidOption: [""],
        cars: [],
        costTrial: [],
        costOfficial: [],
        costTips: [],
      });
    }

    var arr3 = new Array([]);
    arr3.push({
      Filter: `Site Name:${site[0]}|From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (let index = 0; index < arrFixed.length; index++) {
      for (let j = 0; j < arrFixed[index]?.PaidOption?.length; j++) {
        arr3.push({
          serviceType: arrFixed[index].ServiceType,
          serviceTitle: arrFixed[index].ServiceTitle,
          PaidOption: arrFixed[index].PaidOption[j],
          Cars: arrFixed[index]?.cars[j],
          CostTrial: arrFixed[index]?.costTrial[j],
          CostOfficial: arrFixed[index]?.costOfficial[j],
          CostTips: arrFixed[index]?.costTips[j],
        });
      }
    }
    const wsH = XLSX.utils.json_to_sheet(arr2, {
      origin: -1,
    });
    wsH["!cols"] = [
      { width: 70 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    const wsF = XLSX.utils.json_to_sheet(arr3, {
      origin: -1,
    });
    wsF["!cols"] = [
      { width: 70 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsH, "Hourly Services");
    XLSX.utils.book_append_sheet(wb, wsF, "Fixed Services");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const DailySalesLocationExcel = () => {
    var fileName = "Daily Sales By Location Report";
    var DailySalesByLocation = new Array([]);
    DailySalesByLocation.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i < DailySalesByLocationList.length; i++) {
      DailySalesByLocation.push({
        SiteId: DailySalesByLocationList[i].siteId,
        SiteName: DailySalesByLocationList[i].siteName,
        DayDate: DailySalesByLocationList[i].dayDate,
        TicketsCount: DailySalesByLocationList[i].ticketsCount,
        SalesTickets: DailySalesByLocationList[i].salesTickets,
        Tips: DailySalesByLocationList[i].tips,
        ActualTips: DailySalesByLocationList[i].actualTips,
        TotalSales: DailySalesByLocationList[i].totalSales,
        TotalPayrolls: DailySalesByLocationList[i].totalPayrolls,
        HoursCount: DailySalesByLocationList[i].hoursCount,
        TotalReservations: DailySalesByLocationList[i]?.reservationsCount,
        NumberOfReservations: DailySalesByLocationList[i]?.reservationsNumber,
        ReservationsAverage: DailySalesByLocationList[i]?.reservationsAverage,
      });
    }

    const ws = XLSX.utils.json_to_sheet(DailySalesByLocation, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 20 }, { width: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const DailySalesByShiftExcel = () => {
    var fileName = "Daily Sales By Shift Report";
    var DailySalesByShift = new Array([]);
    DailySalesByShift.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To: ${to ? toLocal(to) : ""}`,
    });
    for (var i = 0; i < DailySalesByShiftList.length; i++) {
      DailySalesByShift.push({
        DayDate: DailySalesByShiftList[i].dayDate,
        shiftId: DailySalesByShiftList[i].shiftId,
        startShift: DailySalesByShiftList[i].startShift,
        endShift: DailySalesByShiftList[i].endShift,
        SiteId: DailySalesByShiftList[i].siteId,
        SiteName: DailySalesByShiftList[i].siteName,
        ticketsCount: DailySalesByShiftList[i].ticketsCount,
        salesTickets: DailySalesByShiftList[i].salesTickets,
        tips: DailySalesByShiftList[i].tips,
        totalSales: DailySalesByShiftList[i].totalSales,
      });
    }

    const ws = XLSX.utils.json_to_sheet(DailySalesByShift, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 20 }, { width: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const MonthlySalesLocationExcel = () => {
    var fileName = "Monthly Sales By Location Report";
    var MonthlySalesByLocation = new Array([]);
    MonthlySalesByLocation.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i < MonthlySalesByLocationList.length; i++) {
      MonthlySalesByLocation.push({
        SiteId: MonthlySalesByLocationList[i].siteId,
        SiteName: MonthlySalesByLocationList[i].siteName,
        DayDate: MonthlySalesByLocationList[i].date,
        TicketsCount: MonthlySalesByLocationList[i].ticketsCount,
        SalesTickets: MonthlySalesByLocationList[i].salesTickets,
        Tips: MonthlySalesByLocationList[i].tips,
        TotalPayrolls: MonthlySalesByLocationList[i].totalPayrolls,
        TotalSales: MonthlySalesByLocationList[i].totalSales,
        HoursCount: MonthlySalesByLocationList[i].hoursCount,
      });
    }

    const ws = XLSX.utils.json_to_sheet(MonthlySalesByLocation, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 20 }, { width: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const YearlySalesLocationExcel = () => {
    var fileName = "Yearly Sales By Location Report";
    var YearlySalesByLocation = new Array([]);
    YearlySalesByLocation.push({
      Filter: `From: ${from ? toLocal(from) : ""}| To: ${
        to ? toLocal(to) : ""
      }`,
    });
    for (var i = 0; i < YearlySalesByLocationList.length; i++) {
      YearlySalesByLocation.push({
        Year: YearlySalesByLocationList[i].year,
        TicketsCount: YearlySalesByLocationList[i].ticketsCount,
        SalesTickets: YearlySalesByLocationList[i].salesTickets,
        Tips: YearlySalesByLocationList[i].tips,

        TotalSales: YearlySalesByLocationList[i].totalSales,
      });
    }

    const ws = XLSX.utils.json_to_sheet(YearlySalesByLocation, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 20 }, { width: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const SitesZonesExcel = () => {
    var fileName = "Sites Zones Report";
    var SitesZonesExcelArray = new Array([]);

    for (var i = 0; i < sitesZonesList.length; i++) {
      SitesZonesExcelArray.push({
        SiteId: sitesZonesList[i].siteId,
        SiteName: sitesZonesList[i].siteName,
        SiteStatus: sitesZonesList[i].siteStatus ? "Active" : "Inactive",
        ZoneName: sitesZonesList[i].zoneName,
        ZoneStatus: sitesZonesList[i].zoneStatus ? "Active" : "Inactive",
        ServiceName: sitesZonesList[i].serviceName,
        ServiceStatus: sitesZonesList[i].serviceStatus ? "Active" : "Inactive",
        ServiceTypeName: sitesZonesList[i].serviceTypeName,
        ServicePrice: sitesZonesList[i].servicePrice,
      });
    }

    const ws = XLSX.utils.json_to_sheet(SitesZonesExcelArray, {
      origin: -1,
    });
    ws["!cols"] = [{ width: 70 }, { width: 20 }, { width: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  // Export Search Services excel function
  const ExportSearchServicesToExcel = async () => {
    // for (var i = 2; i <= countSearchServiceExcel; i++) {
    //   await fetchSearchByServicesExcel(
    //     FilterData?.cid,
    //     FilterData?.sids,
    //     i,
    //     100,
    //     FilterData,
    //   );
    // }
    // var newArr = new Array([]);
    // for (let i = 0; i < ExportSearchServicesExcelList?.length; i++) {
    //   newArr = newArr.concat(ExportSearchServicesExcelList[i]);
    // }

    // newArr.forEach((a) => {
    //   a["checkInDate"] = a["checkInDate"]
    //     ? tolocalDate(a?.["checkInDate"])
    //     : "";
    //   a["checkOutDate"] = a["checkOutDate"]
    //     ? tolocalDate(a?.["checkOutDate"])
    //     : "";

    //   delete a.id;
    // });

    // newArr = newArr.flatMap((item) => {
    //   if (!item.services) return [item];

    //   return item.services.map((service) => ({
    //     ...item,
    //     services: service.name,
    //     Cost: service?.cost,
    //   }));
    // });
    // var fileName = "Search By Services Report File";
    // const ws = XLSX.utils.json_to_sheet(newArr, {
    //   origin: -1,
    // });
    // ws["!cols"] = [
    //   { width: 50 },
    //   { width: 50 },
    //   { width: 50 },
    //   { width: 50 },
    //   { width: 15 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 15 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 25 },
    //   { width: 15 },
    //   { width: 15 },
    //   { width: 15 },
    //   { width: 15 },
    //   { width: 15 },
    // ];
    // const wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, "Search By Services");
    // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    // const data = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(data, fileName + fileExtension);

    try {
      await ExportExcelBackendSearchByService(
        FilterData?.cid,
        FilterData?.sids,
        FilterData,
      );
    } catch (error) {
      console.log(error, "error");
    }
  };
  // Export Sales End Shift excel function
  const ExportSalesEndShiftToExcel = async () => {
    for (var i = 2; i <= countEndShiftExcel; i++) {
      await fetchSalesEndShiftExcel(
        FilterData?.cid,
        FilterData?.sids,
        i,
        100,
        FilterData,
      );
    }
    var newArr = new Array([]);
    for (let i = 0; i < ExportSalesEndShiftExcel?.length; i++) {
      newArr = newArr.concat(ExportSalesEndShiftExcel[i]);
    }

    const updatedArr = newArr.map((a) => {
      const { id, ...rest } = a;
      return {
        ...rest,
        startShift: a.startShift ? safeLocalFormat(a.startShift) : "",
        endShift: a.endShift ? safeLocalFormat(a.endShift) : "",
        expensePaymentsList:
          a?.expensePaymentsList
            ?.map((payment) => `${payment.expenseTitle}: ${payment.amount}`)
            .join(", ") ?? "",
      };
    });

    var fileName = "Sales End Shift Report File";
    const ws = XLSX.utils.json_to_sheet(updatedArr, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sales End Shift");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const LiveTransactionToExcel = async () => {
    for (var i = 2; i <= countLiveExcel; i++) {
      await fetchLiveTransactionExcel(FilterData, i, 100);
    }
    var newArr = new Array([]);

    for (let i = 0; i < ExportLiveTransactionExcel.length; i++) {
      newArr = newArr.concat(ExportLiveTransactionExcel[i]);
    }
    newArr.forEach((a) => {
      a["paidStatusId"] = a["paidStatusId"]
        ? getPaidStatusTitle(a?.["paidStatusId"])
        : "";
      delete a.id;
      delete a.statusId;
      delete a.smsStatusId;
      delete a.zoneId;
      delete a.requestedGateId;
      delete a.costType;
      delete a.costTypeId;
      delete a.firstServicesTitle;
      delete a.inHouse;
      delete a.spot;
    });
    var fileName = "Live Transactions Report File";
    const ws = XLSX.utils.json_to_sheet(newArr, {
      origin: -1,
    });
    ws["!cols"] = [
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleTransactionCheckedOutExportExcel = async () => {
    for (let i = 2; i <= countExcel; i++) {
      await fetchTransactionCheckedOutExcel(FilterData, i, 100);
    }
    let newArr = [];
    for (let i = 0; i < ExportTransactionsCheckedOutExcel?.length; i++) {
      newArr = newArr.concat(ExportTransactionsCheckedOutExcel[i]);
    }
    newArr.forEach((a) => {
      a["checkInDate"] = safeLocalFormat(a["checkInDate"]);
      a["checkOutDate"] = safeLocalFormat(a["checkOutDate"]);
      a["requestDate"] = safeLocalFormat(a["requestDate"]);
    });

    const fileName = "Transactions CheckedOut Report File";
    const ws = XLSX.utils.json_to_sheet(newArr, { origin: -1 });
    ws["!cols"] = Array(8).fill({ width: 50 }); // shorthand
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Info");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const handleClick = async () => {
    setIsExporting(true);

    try {
      switch (params.name) {
        case "Transactions":
          await handleExportExcel();
          break;
        case "Voids":
          await handleVoidExportExcel();
          break;
        case "TransactionsServicePayment":
          await handlePaySerExportExcel();
          break;
        case "Shift":
          await handleShiftExportExcel();
          break;
        case "EmployeesRoles":
          await EmployeeRoleExcel();
          break;
        case "DailySales":
          await DailySalesExcel();
          break;
        case "DailySalesByShift":
          await DailySalesByShiftExcel();
          break;
        case "SitesByTickets":
          await TicketExcel();
          break;
        case "SiteBySales":
          await SalesExcel();
          break;
        case "TransactionsByService":
          await TransactionServicesExcel();
          break;
        case "LessPayroll":
          await LessPayrollExcel();
          break;
        case "HighestPayroll":
          await HighPayrollExcel();
          break;
        case "DailySalesLocation":
          await DailySalesLocationExcel();
          break;
        case "MonthlySalesLocation":
          await MonthlySalesLocationExcel();
          break;
        case "YearlySalesLocation":
          await YearlySalesLocationExcel();
          break;
        case "SitesZonesServices":
          await SitesZonesExcel();
          break;
        case "SearchByServices":
          await ExportSearchServicesToExcel();
          break;
        case "SalesEndShift":
          await ExportSalesEndShiftToExcel();
          break;
        case "Live":
          await LiveTransactionToExcel();
          break;
        case "TransactionsCheckedOut":
          await handleTransactionCheckedOutExportExcel();
          break;
        default:
      }
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      {role !== "Site" && (
        <Typography variant="Poster" component="h4">
          {params.name === "Transactions" ||
          params.name === "Shift" ||
          params.name === "Voids" ||
          params.name === "TransactionsByService" ? (
            <>Select Company & Site (At least)</>
          ) : (
            <>Select Company & From Date & To Date</>
          )}
        </Typography>
      )}

      <FilterForm
        obj={getObj(params.name)}
        PageName={selectedCols}
        filterClick={filterClick}
        setFilterClick={setFilterClick}></FilterForm>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "80%",
        }}>
        <TabsList
          tabs={tabs}
          setSelectedCols={setSelectedCols}
          selectedCols={selectedCols}></TabsList>
        {filterClick && (
          <Button
            sx={{
              border: `1px solid ${theme.color.Screamingreen}`,
              color: theme.color.Screamingreen,
              mt: "5px",
              textTransform: "capitalize",
              "&:hover": {
                background: isExporting ? "inherit" : `${theme.color.gray50}`,
              },
              opacity: isExporting ? 0.7 : 1,
              cursor: isExporting ? "not-allowed" : "pointer",
            }}
            onClick={isExporting ? undefined : handleClick}
            disabled={isExporting}>
            {isExporting ? (
              <>
                <CircularProgress
                  size={20}
                  sx={{
                    color: theme.color.Screamingreen,
                    mr: 1,
                  }}
                />
                Exporting...
              </>
            ) : (
              "Export to Excel"
            )}
          </Button>
        )}
      </div>
      <CustomTable
        empty={getData(selectedCols)?.length === 0 ? true : false}
        cols={getCols(selectedCols)}
        data={getData(selectedCols)}
        showButton={true}
        moreOptions={
          selectedCols === "Shift Reports" && {
            detail: handleDetail,
          }
        }
        filters={{
          pagination: true,
          page: perPage,
          changePageSize: changePageSize,
          searchDropdown: true,
        }}
        actions={
          params.name === "Live" && {
            PaidStatus: true,
          }
        }
        page={page}
        rowsPerPage={10}
        dispatch={dispatch}
        count={
          (params.name === "Transactions" && count) ||
          (params.name === "Shift" && countShift) ||
          (params.name === "Voids" && countVoid) ||
          (params.name === "SearchByServices" && countSearchServices) ||
          (params.name === "SalesEndShift" && countSalesEndShift) ||
          (params.name === "Live" && countLive) ||
          (params.name === "TransactionsCheckedOut" && countCheckedOut)
        }
        isPagination={
          params.name === "Transactions" ||
          params.name === "Shift" ||
          params.name === "Voids" ||
          params.name === "SearchByServices" ||
          params.name === "SalesEndShift" ||
          params.name === "Live" ||
          params.name === "TransactionsCheckedOut"
            ? true
            : false
        }
        ExpandRow={params?.name === "DailySales" ? true : false}
        nameColumn={params.name}></CustomTable>
    </>
  );
}

export default ReportPage;
